import type { ImportProblem } from './catalog';
import type { ShippingModel } from './shipping';

// Manual orders: sales outside the integrated marketplaces (Instagram, WhatsApp, B2B, the
// seller's own web shop) entered in the seller portal one by one or from an Excel / CSV sheet.
// The seller picks the carrier; the label is made right away through its contract.

/** A carrier a seller can ship a manual order with. */
export interface CarrierOption {
  readonly code: string;
  /** "Aras Kargo" */
  readonly name: string;
  /** the contract's own label */
  readonly label: string;
  /** the warehouse's contract (re-billed by the barem) or the seller's own */
  readonly shippingModel: Extract<ShippingModel, 'seller_contract' | 'warehouse_contract'>;
  /** api: the carrier's API registers the parcel (Aras Kargo); pool: numbers from the range the carrier assigned */
  readonly integration: 'api' | 'pool';
  /** an API answered by its sandbox: labels say TEST */
  readonly sandbox: boolean;
  /** an API carrier needs its integration installed on the server */
  readonly available: boolean;
  readonly isDefault: boolean;
}

/** Where sellers usually sell outside the marketplaces (the form offers these; any text is accepted). */
export const ORDER_SOURCES = ['Instagram', 'WhatsApp', 'B2B toptan', 'Web sitesi', 'Telefon'] as const;

export interface ManualOrderImportPreview {
  /** sheet rows of the order, "2" or "2–4" */
  readonly rows: string;
  /** null: numbered when created */
  readonly orderNumber: string | null;
  readonly customerName: string;
  readonly city: string;
  readonly lines: number;
  readonly units: number;
  /** carrier name, null when none is chosen */
  readonly carrier: string | null;
  readonly action: 'create' | 'error';
}

/** What an order sheet would create (dry run) or created. */
export interface ManualOrderImportResult {
  readonly dryRun: boolean;
  readonly rows: number;
  readonly orders: number;
  readonly units: number;
  readonly errors: readonly ImportProblem[];
  readonly ignoredColumns: readonly string[];
  readonly preview: readonly ManualOrderImportPreview[];
  /** the orders made (empty on a dry run) */
  readonly created: readonly { readonly id: string; readonly orderNumber: string }[];
}
